import { czResult } from '@/api/wenjuan/publishQuestion'
import { transformLoadingFunction } from '@/assets/js/el-loading'
import { getYuE } from '@/api/wenjuan/reward'

const msgOkArr = ['成功']
const msgErrArr = ['转入退款', '已关闭', '已撤销', '支付失败']
const msgMap = []
msgOkArr.forEach(msg => {
  msgMap.push({
    type: 'success',
    msg
  })
})
msgErrArr.forEach(msg => {
  msgMap.push({
    type: 'error',
    msg
  })
})
let payFlag = true

export function setPayFlag(flag) {
  payFlag = flag
}

export function getRechargeResult(data) {
  if (getRechargeResult.timers) {
    clearTimeout(getRechargeResult.timers)
  }
  getRechargeResult.flag = true
  let innerId = data.innerId
  let surveyId = data.surveyId
  let successCallback = data.success
  let originBalance = data.balance
  return new Promise((resolve, reject) => {
    const getResultFnc = () => {
      if (getRechargeResult.flag) {
        czResult({ innerId, surveyId })
          .then(res => {
            let msg = res.data.data.chargeResult
            let findObj = msgMap.find(item => item.msg === msg)
            if (findObj) {
              getRechargeResult.flag = false
              if (findObj.type !== 'success') {
                return Promise.reject(findObj)
              } else {
                successCallback && successCallback()
                return Promise.resolve()
              }
            }
            setTimeout(() => {
              getResultFnc()
            }, 1000)
            return Promise.reject()
          })
          .then(() => {
            let flag = true
            const load = transformLoadingFunction('正在获取结果')
            const getBalanceResult = () => {
              if (!flag) return
              getYuE()
                .then(res => {
                  if (parseFloat(res.data.data) === parseFloat(originBalance)) {
                    getBalanceResult()
                  } else {
                    flag = false
                    load.close()
                    resolve()
                  }
                })
                .catch(() => {
                  resolve()
                })
            }
            getBalanceResult()
          })
          .catch(err => {
            if (err) {
              reject(err)
              return
            }
            return Promise.resolve()
          })
      }
    }
    getResultFnc()
    getRechargeResult.timers = setTimeout(() => {
      if (!getRechargeResult.flag) return
      getRechargeResult.flag = false
      reject()
    }, 1000 * 120)
  })
}

function loop(expire) {
  if (expire < Date.now()) {
    return Promise.reject({ message: '超时', expire: true })
  } else {
    return getYuE()
  }
}

export function checkIsOk(expire, oldBalance, successCb, errorCb) {
  setTimeout(() => {
    if (payFlag) {
      loop(expire)
        .then(res => {
          let newBalance = Number(res.data.data)
          oldBalance = Number(oldBalance)
          // 由于最少充值一元 +0.5 是为了让 newBalance 必须保证大于oldBalance js 精度问题
          if (newBalance > oldBalance + 0.5) {
            successCb && successCb(newBalance)
          } else {
            checkIsOk(expire, oldBalance, successCb, errorCb)
          }
        })
        .catch(errorCb)
    }
  }, 2000)
}
